<div class="flex flex-row-reverse gap-4 md:gap-9 pb-5">
  <!-- Hospitable Icon -->
  <sbnb-profile-img [src]="avatar" alt="Hospitable"></sbnb-profile-img>

  <!-- Message Content -->
  <div class="flex flex-col items-end w-full md:w-3/4" style="gap: 12px">
    <div class="message-card bg-warning-50">
      <div class="thread_message-auto-inner">
        <!-- Title -->
        <div class="mb-4 flex items-center gap-2">
          <ui-icon icon="griddy-sticky-note" [size]="16"></ui-icon>
          <b>{{ type === 'ai' ? 'Note • AI Summary' : 'Note' }}</b>
        </div>
        <div *ngIf="type === 'ai'">
          {{ text }}
        </div>
        <div *ngIf="type === 'internal'" [innerHTML]="cleanedHtml | safe: 'html'"></div>
      </div>
    </div>
    <div class="text__xsmall night flex items-center gap-1">
      <span>Noted by {{ author }}, {{ created_at_label }}</span>
    </div>
  </div>
</div>
